import './index.scss'

import { Image } from '@chakra-ui/react'
import { Link } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'

import { Box } from '@/components/ui/box'
import { Flex } from '@/components/ui/flex'
import { Text } from '@/components/ui/typography'
import { appEnvName, currentEnv } from '@/env/vars.ts'
import { useMobileDetection } from '@/hooks/useMobileDetection.ts'

import HelpCenter from './components/helpCenter'
import HeaderMenu from './components/menu'
import Navigation from './components/navigation'
import NewsReleases from './components/newsReleses'

const appEnv = appEnvName === 'prod' ? '' : appEnvName

const Header = () => {
    const { t } = useTranslation()
    const { isMobile } = useMobileDetection()
    return (
        <Box p={4} className={`mainHeader ${appEnv} ${appEnv && 'lower-env-bg'}`}>
            <Flex alignItems="center" justifyContent="space-between">
                <Box display="flex" alignItems="center">
                    <Box flexShrink={0}>
                        <Link to="/">
                            <Image src="/assets/GSK-logo.png" alt="GSK Logo" mr="16px" ml="16px" height="36px" width="120px" />
                        </Link>
                    </Box>
                    <Box alignItems="center" display="flex" mr="16px">
                        <Text fontSize="14x" letterSpacing="0.25px" lineHeight="20px">
                            {t('global.header.title')}
                            {appEnv && (
                                <>
                                    <br />
                                    <Text
                                        as="span"
                                        color="orangered"
                                        display="inline"
                                        textTransform="uppercase"
                                        fontWeight="bold"
                                    >{` (${appEnv} Environment)`}</Text>
                                </>
                            )}
                        </Text>
                    </Box>
                </Box>
                <Flex alignItems="center" justifyContent="space-between">
                    {!isMobile && (
                        <>
                            <Navigation />
                            {currentEnv.features.isEnabled('news') && <NewsReleases />}
                            <HelpCenter />
                            <HeaderMenu />
                        </>
                    )}
                </Flex>
            </Flex>
        </Box>
    )
}

export default Header
